import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../common/api/ApiRequestAdapter";
import { apiService } from "../../common/api/apiService";
import { HttpMethod } from "../../common/api/http";
import { PageSizes } from "../../common/constants";
import { EntityIdObject, EntityObject } from "../../common/types";
import {
  CoverageLimit,
  CoverageLimitFilterPageRequest,
  CoverageLimitFilterPageResult,
  CreateUpdateCoverageLimit,
} from "./types";

const FILTER_COVERAGE_LIMITS = ApiRequestAdapter.create("/coverage-limits", HttpMethod.GET);
const CREATE_COVERAGE_LIMIT = ApiRequestAdapter.create("/coverage-limits", HttpMethod.POST);
const UPDATE_COVERAGE_LIMIT = ApiRequestAdapter.create("/coverage-limits/{0}", HttpMethod.PUT);
const DELETE_COVERAGE_LIMIT = ApiRequestAdapter.create("/coverage-limits/{0}", HttpMethod.DELETE);

export const coverageLimitApi = {
  filterCoverageLimits: (request: CoverageLimitFilterPageRequest): AxiosPromise<CoverageLimitFilterPageResult> => {
    return apiService.get(FILTER_COVERAGE_LIMITS.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  createCoverageLimit: (request: CreateUpdateCoverageLimit): AxiosPromise<CoverageLimit> => {
    return apiService.post(CREATE_COVERAGE_LIMIT.url, request);
  },
  updateCoverageLimit: (request: EntityObject<CreateUpdateCoverageLimit>): AxiosPromise<CoverageLimit> => {
    return apiService.put(UPDATE_COVERAGE_LIMIT.getParametrizedUrl(request.id), request.object);
  },
  deleteCoverageLimit: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_COVERAGE_LIMIT.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_COVERAGE_LIMITS_QUERY_PARAMS: Required<CoverageLimitFilterPageRequest> = {
  institutionIds: [],
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
};
